var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn btn-sm btn-clean btn-icon",class:[_vm.hover],attrs:{"type":"button","title":_vm.title}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }